import { ContactModule } from "./contact.types";

const nonEmpty = (value?: string): boolean => Boolean(value?.trim());

export const hasVisibleContact = (contact?: ContactModule): boolean =>
  Boolean(
    contact?.emails?.some(nonEmpty) ||
      contact?.phones?.some(nonEmpty) ||
      nonEmpty(contact?.address?.es) ||
      nonEmpty(contact?.address?.en) ||
      (contact?.social && Object.values(contact.social).some(nonEmpty))
  );

export const createTelephoneUrl = (phone?: string): string | undefined => {
  const normalized = phone?.replace(/[^\d+]/g, "");
  return normalized ? `tel:${normalized}` : undefined;
};

export const createEmailUrl = (email?: string): string | undefined =>
  email?.trim() ? `mailto:${email.trim()}` : undefined;
